import styled from "@emotion/styled";
import { type Attachment } from "@repo/api";
import { t } from "@repo/translation";
import { hasItems } from "@repo/utils";

import { ProjectFileItem } from "../fileListItem/ProjectFileItem";
import { sortProjectAttachments } from "../utils";
import { AttachmentAccordionItem, type FilesListBaseProps } from "./FilesList";

const FileList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

interface ProjectFilesListProps extends FilesListBaseProps {
  files?: Attachment[];
}

export const ProjectFilesList = ({
  files,
  editable,
  loading,
  loadingFileId,
  onDownload,
  onDelete,
  onShare,
}: ProjectFilesListProps) => {
  const sortedProjectAttachments = sortProjectAttachments(files);

  if (!hasItems(sortedProjectAttachments)) {
    return null;
  }
  return (
    <AttachmentAccordionItem
      id="project-attachments"
      title={`${t("type.sales_project")} (${sortedProjectAttachments.length})`}
      open
    >
      <FileList>
        {sortedProjectAttachments.map((file) => (
          <ProjectFileItem
            key={`attachment-${file.name}`}
            file={file}
            editable={editable}
            onDownload={onDownload}
            onDelete={onDelete}
            loading={loading}
            loadingFileId={loadingFileId}
            onShare={onShare}
          />
        ))}
      </FileList>
    </AttachmentAccordionItem>
  );
};
